import { WprModel } from '../../wpr-framework/view/deco/WprModel';
import { WprDI_ScopeModel } from '../../wpr-framework/view/di/WprDI_ScopeModel';
import { BasicInfo } from '../../models/BasicInfo';
import { SecondScopeInfo } from '../../scope/SecondScopeInfo';
import { CreditCheckInputMode } from './mode/CreditCheckInputMode';
import { WprViewMode } from '../../wpr-framework/view/deco/WprViewMode';
import { BaseWindowViewScope } from '../base/BaseWindowViewScope';
import { WprValidError } from '../../wpr-framework/view/validation/WprValidError';
import { WprControlInfo } from '../../wpr-framework/view/control/WprControlInfo';
import { WprDI_Control } from '../../wpr-framework/view/di/WprDI_Control';
import { ContractorInfo } from '../../models/ContractorInfo';
import { WprValueMap } from '../../wpr-framework/model/WprValueMap';
import { WprDI_GlobalScopeModel } from '../../wpr-framework/view/di/WprDI_GlobalScopeModel';
import { SettlementContractRequest } from '../../service/service-models/settlement/SettlementContractRequest';
import { RiskFactorInfo } from '../../service/models/risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../../service/models/select-plan/select-plan-info';
import { PaymentInfo } from '../../service/models/payment/payment-info';
import { LoginInfo } from '../../models/LoginInfo';
import { PolicyHolderInfo } from '../../service/models/policy-holder/policy-holder-info';
import { WprListData } from '../../wpr-framework/view/deco/WprListData';
import { InsuredInfo } from '../../service/models/insured/insured-info';
import { PolicyContractInfo } from '../../service/models/policy-contract/policy-contract-info';
import { SettlementService } from '../../service/SettlementService';
import { MdkTokenService } from '../../service/MdkTokenService';
import { MdkTokenRequest } from '../../service/service-models/veritrans/MdkTokenRequest';
import { MdkTokenResult } from '../../service/service-models/veritrans/MdkTokenResult';
import { SettlementContractResult } from '../../service/service-models/settlement/SettlementContractResult';
import { AuthMailInfo } from '../../service/models/auth-mail/auth-mail-info';

export let cardYearPlaceHolder: string = null;		// 有効期限（年）プレースホルダー

/**
 * クレジット払いビュー情報
 */
export class CreditComponentView extends BaseWindowViewScope<SecondScopeInfo> {
	// モデル -------------------------------------------------------------------
	@WprDI_GlobalScopeModel('product')
	private m_ProductCode:			 string 			= null;
	@WprDI_ScopeModel('BasicInfo')
	@WprModel('BasicInfo')
	private m_BasicInfo:			BasicInfo 			= null;	// 基本情報
	@WprDI_ScopeModel('AuthMailInfo')
	private m_AuthMailInfo: 		AuthMailInfo 		= null; // 契約者（申込者）情報
	@WprDI_ScopeModel('ContractorInfo')
	private m_ContractorInfo: 		ContractorInfo 		= null; // 契約者（申込者）情報
	@WprDI_ScopeModel('RiskFactorInfo')
	private m_RiskFactorInfo:		RiskFactorInfo 		= null;	// リスクファクター情報
	@WprDI_ScopeModel('SelectPlanInfo')
	private m_SelectPlanInfo: 		SelectPlanInfo		= null;	// 選択プラン情報
	@WprDI_ScopeModel('LoginInfo')
	private m_LoginInfo: 			LoginInfo 			= null; // ログイン情報
	@WprDI_ScopeModel('PolicyHolderInfo')
	private m_PolicyHolderInfo: 	PolicyHolderInfo	= null; // 契約者情報（サービス）
	@WprDI_ScopeModel('InsuredInfoList')
	private m_InsuredInfoList: 		InsuredInfo[]		= null; // 旅行者リスト情報（サービス）
	@WprDI_GlobalScopeModel('AuthMailId')
	private m_AuhtMailId: string						= null;
	@WprModel('cardName')
	private m_CardName:		string			= null;	// カード名義
	@WprDI_Control
	private m_CardNo:		WprControlInfo = null;	// カード番号
	@WprDI_Control
	private m_CardMonth:	WprControlInfo = null;	// カード有効期限（月）
	@WprDI_Control
	private m_CardYear:		WprControlInfo = null;	// カード有効期限（年）
	@WprModel('securityCode')
	private m_CardRimit:	string 		   = null;	// セキュリティコード
	// --------------------------------------------------------------------------

	// サブビュー/モード  ---------------------------------------------------------
	@WprViewMode
	private m_ViewMode = new CreditCheckInputMode(); // ボタン活性判定モード
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('step7_creditcard');
	}
	// --------------------------------------------------------------------------

	// サービス  -----------------------------------------------------------------
	private m_SettlementService: SettlementService = new SettlementService(); // 締結サービス

	private m_MdkTokenService: MdkTokenService = new MdkTokenService();
	// --------------------------------------------------------------------------

	private m_ApiKey: any = null;
	
	// override メソッド  --------------------------------------------------------
	/**
	 * コントロール定義設定
	 */
	public onRegisterConfig(): void {
		this.addConfig('cardNo',		'カード番号',				null,		{ hissu: true, maxLength: 16, minLength:12, noEditClass: 'first', errorClass: 'error', validation: '整数'});
		this.addConfig('cardName',		'カード名義',			'cardName',		{ bindModel:true, hissu: true, maxLength: 24, errorClass: 'error', validation: 'クレジットカード名義' });
		this.addConfig('cardMonth',		'カード有効期限（月）',		 null,	     { hissu: true, noEditClass: 'first', errorClass: 'error', });
		this.addConfig('cardYear',		'カード有効期限（年）',		 null,		 { hissu: true, noEditClass: 'first', errorClass: 'error', });
		this.addConfig('cardRimit',		'セキュリティコード',	 'securityCode', { bindModel:true, hissu: true, maxLength: 4, minLength: 3, noEditClass: 'first', errorClass: 'error', validation: '整数'});
		this.addConfig('insuranceFee',	'合計保険料', 			'BasicInfo');
	}

	/**
	 * アクション登録
	 */
	public onRegisterAction(): void {
		this.addAction('aboutSC',				this.onOpenModal);
		this.addAction('closeSCButton',			this.onCloseModal);
		this.addAction('creditSettleButton',	this.onSettlementCredit);
		this.addBlurAction('cardNo',	null, true);
		this.addBlurAction('cardName',	null, true);
		this.addBlurAction('cardMonth',	null, true);
		this.addBlurAction('cardYear',	null, true);
		this.addBlurAction('cardRimit',	null, true);
	}

	/**
	 * バリデーションエラーメッセージ通知
	 * @param name コントロール名
	 * @param rowIndex 行数(Listの場合)
	 * @param validatorName バリデーション名
	 * @param msg エラーメッセージ
	 * @returns エラーメッセージ（変更する場合に指定する、メッセージを使用しない場合は、nullを返す）
	 */
	public onInvalidMessage(name: string, rowIndex: number, validatorName: string, msg: string): string {
		if (validatorName === '必須'){
			if (name === 'cardMonth' || name === 'cardYear')
				return 'カード有効期限を入力してください';
			else 
				return msg;
		}
		if (name === 'cardNo') 
			return 'クレジットカード番号が有効ではありません。ご確認ください。';
		if (name === 'cardName') 
			return 'カード名義が有効ではありません。ご確認ください。';
		if (name === 'cardRimit') 
			return 'セキュリティコードが有効ではありません。ご確認ください。';
		return msg;
	}

	/**
	 * 入力チェック（独自のValidationを実施する場合に使用する）
	 *   エラー追加例：WprValidError.addError('エラーメッセージ');
	 * 				  this.setControlError('control', 'error');
	 * @param actionName アクション名
	 * @param validError バリデーションエラー情報
	 */
	protected onValid(actionName: string, validError: WprValidError): void {
		if (this.m_CardNo.value && actionName === 'cardNo') {
			if (this.checkDigit(this.m_CardNo.value) == false)
				this.setControlError('cardNo', 'クレジットカード番号が有効ではありません。ご確認ください。');
		}
		if (this.m_CardYear.value && this.m_CardMonth.value && (actionName === 'cardYear' || actionName === 'cardMonth')) {
			if (this.checkExpired() == false) {
				this.setControlError('cardYear', 	'有効期限が過ぎています。ご確認ください。');
				this.setControlError('cardMonth', 	'有効期限が過ぎています。ご確認ください。');
			}
			else {
				this.clearControlError('cardYear',	'有効期限が過ぎています。ご確認ください。');
				this.clearControlError('cardMonth',	'有効期限が過ぎています。ご確認ください。');
			}
		}
	}

	/**
	 * ビュー表示通知
	 */
	public onShowView(): void {
		super.onShowView();
		if (!this.m_ContractorInfo || !this.m_BasicInfo || !this.m_AuthMailInfo) {
			this.onViewError();
		}
		else {
			this.m_CardName = (this.m_ContractorInfo.romanFirstName + ' ' + this.m_ContractorInfo.romanLastName).toUpperCase();
			this.setExpiredYearValueMap(this.m_BasicInfo.applicationDate);
			fetch(process.env.API_URL + '/mdkConfig.json').then((result) =>
				result.json()
			).then((json) => {
				this.m_ApiKey = json.TOKEN_API_KEY;
			});
			this.onUtagView();
			this.refreshView();
			$('#id-card_no').off('click');
			$('#id-card_name').off('click');
			$('#id-card_rimit').off('click');
		}
	}
	
	/**
	 * ロストフォーカス通知
	 * @param name コントロール名称
	 * @param value コントロール値
	 * @returns コントロール値（コントロール値を変更しない場合は、valueをそのまま返す）
	 */
	public onBlur(name: string, value: any): any {
		if (name === 'cardName') {
			const str = value.replace(/　/g, ' ').replace(/[Ａ-Ｚａ-ｚ０-９＠＿－．]/g, function (match) {
				return String.fromCharCode(match.charCodeAt(0) - 0xFEE0);
			});
			return str.toUpperCase();
		}
		return value;
	}

	/**
	 * 商品コード取得
	 */
	public get productCode(): string { 
		return this.m_ProductCode; 
	}
	// --------------------------------------------------------------------------

	// アクション  ---------------------------------------------------------------
	/**
	 * 決済して締結
	 * @param param 
	 */
	public onSettlementCredit(param: any): void {
		this.refreshModel();
		// Token発行
		const mdkReq: MdkTokenRequest = new MdkTokenRequest();
		mdkReq.card_number = this.m_CardNo.value;
		mdkReq.card_expire = this.m_CardMonth.value + '/' + this.m_CardYear.value;
		mdkReq.security_code = this.m_CardRimit;
		mdkReq.token_api_key = this.m_ApiKey;
		// if (mdkReq.token_api_key === null || mdkReq.token_api_key === undefined)
		// 	mdkReq.token_api_key = mdkConfig.TOKEN_API_KEY;
		this.m_MdkTokenService.getMdkToken(this, mdkReq, (result) => {
			const mdkRes: MdkTokenResult = result as MdkTokenResult;
			const req = this.setSettlementReq();
			req.paymentInfo.cardNo = mdkRes.req_card_number;
			req.paymentInfo.tokenNo = mdkRes.token;
			req.paymentInfo.cardHolder = this.m_CardName;
			// クレジット決済
			this.m_SettlementService.settlementByCredit(this, req, (result2) => {
				const settlementRes: SettlementContractResult = result2 as SettlementContractResult;
				this.m_LoginInfo.loginId = settlementRes.bookingNo;
				let polNums: string = '';
				for (let i: number = 0; i < settlementRes.policyNumberList.length; i++) {
					polNums = polNums + settlementRes.policyNumberList[i];
					if (i + 1 !== settlementRes.policyNumberList.length)
						polNums = polNums + ', ';
				}
				this.m_BasicInfo.contractNumber = polNums;
				this.pushPath('/step8_make-contract');
			});
		});
		// this.m_SettlementService.settlementByCredit(this, req, (result) =>{
		// 	this.m_BasicInfo.contractNumber = result.policyNumber;
		// 	this.m_LoginInfo.loginId		= result.bookingNo;
		// 	this.pushPath('/step8_make-contract');
		// });
	}

	/**
     * ヘルプ表示処理
     * @param param 
     */
	public onOpenModal(param: any): void {
		this.setViewMode('avoutSCModal', '表示');
	}

	/**
     * ヘルプを閉じる
     * @param param 
     */
	public onCloseModal(param: any): void {
		this.setViewMode('avoutSCModal', '');
	}
	// --------------------------------------------------------------------------
	
	// private ------------------------------------------------------------------
	/**
	 * クレジットカード有効期限（年）ValueMap設定
	 * @param mappintList マッピング情報リスト
	 */
	private setExpiredYearValueMap(applicationDate: string): void {
		const thisYear = Number(applicationDate.slice(2,4));
		const vmName = 'cc-exp-year';
		if (this.hasValueMap(vmName) === false) {
			const vm = new WprValueMap();
			for(let i = 0; i < 20; i++)
				vm.addValue(String(thisYear + i), String(thisYear + i));
			this.addValueMap(vmName, vm);
		}
		cardYearPlaceHolder = '例）' + thisYear;
	}
	
	/**
	 * 有効期限が過ぎているかどうか判定
	 * 		有効である：true
	 * 		有効でない：false
	 */
	private checkExpired(): boolean {
		const cardExpired		= Number(this.m_CardYear.value + this.m_CardMonth.value);
		// const applicationDate	= this.m_BasicInfo.applicationDate;
		const applicationDate	= this.m_AuthMailInfo.applicationDate;
		const systemDate		= Number(applicationDate.slice(2,4) + applicationDate.slice(5,7));
		if (cardExpired < systemDate)	
			return false;
		return true;
	}
	
	/**
	 * SettlementConotractReqセット
	 */
	private setSettlementReq(): SettlementContractRequest{
		const req: SettlementContractRequest = new SettlementContractRequest();
		// const today = String(new Date());
		const today = this.m_AuthMailInfo.applicationDate;
		req.transactionDate		= today.replace(/(\d+)\/(\d+)\/(\d+)/g, '$1-$2-$3');
		req.riskFactorInfo		= this.m_RiskFactorInfo;
		req.selectPlanInfo		= this.m_SelectPlanInfo;
		req.policyContractInfo	= new PolicyContractInfo;
		req.policyContractInfo.insuredInfoList	= this.m_InsuredInfoList;
		req.policyContractInfo.policyHolderInfo = this.m_PolicyHolderInfo;
		req.paymentInfo			= new PaymentInfo();
		req.paymentInfo.tokenNo			= ''; 				  // TODO　締結処理後に発行
		req.paymentInfo.paymentType 	= 'CC';
		req.paymentInfo.paymentMethod 	= 'クレジットカード';	// 仮？
		req.paymentInfo.cardType		= null;				  // NULLのまま
		req.paymentInfo.cardHolder		= this.m_CardName;
		req.inquiryPassword 			= this.m_LoginInfo.loginPass;
		req.authMailId					= this.m_AuhtMailId;
		return req;
	}

	/**
	 * 有効なクレジットカード番号か判定
	 * 		有効である：true
	 * 		有効でない：false
	 * @param cardNo カード番号
	 */
	private checkDigit(cardNo: string): boolean {
		let sum = Number(cardNo.slice(-1));
		for(let i = 2; i <= cardNo.length; i++) {			
			let num = Number(cardNo.slice(-i, -i+1));
			if (i%2 === 0){
				num *= 2;
				if (num >= 10) 
					num -= 9;
			}
			sum += num;
		}
		if (sum%10 === 0) 
			return true;
		return false;
	}
	// --------------------------------------------------------------------------
}